// The portal serves one US pharmacy operation, so every timestamp is shown in Dallas time
// regardless of where the pharmacist's machine is set. moment-timezone augments the shared
// moment instance, so setting the default here applies to every `moment(...)` call in the app.
// The 10 year data build keeps the timezone database out of the main bundle weight.
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

export const APP_TIME_ZONE = "America/Chicago";

moment.tz.setDefault(APP_TIME_ZONE);

export default moment;
